export default __webpack_public_path__ + "static/media/Teddington-01.40f96eb0.jpg";